module.exports = __webpack_public_path__ + "static/img/65.bdad973b.png";